<mat-dialog-content class="text-center">
    <p class="text-[#0A0A0A] text-[1.125rem] font-semibold mt-4 mb-6">Please Verify Your Email</p>
    <p class="text-[#717182]">
        We have sent a link to <span class="text-[#0A0A0A]">{{ data }}</span
        >.
    </p>
    <p class="text-[#717182]">Please verify your email via the link.</p>
    <p class="text-[#717182] mt-10">Didn't receive the email?</p>
    <p class="inline-block border-b-2 border-[#4f66ff] text-[#4f66ff] cursor-pointer" (click)="resendVerifyEmail()">
        Resend Email
    </p>
</mat-dialog-content>

<mat-dialog-actions>
    <button type="button" class="w-full border-button py-3 rounded-2xl" (click)="onOkay()">
        {{ confirmButtonLabel }}
    </button>
</mat-dialog-actions>
